import {
  AccountState,
  IAccount,
  LicensePackage,
} from '@account-users/account/models';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { AccountTrialUpgradeModalComponent } from '../account-trial-upgrade-modal/account-trial-upgrade-modal.component';

@Component({
  selector: 'app-account-trial-upgrade',
  templateUrl: './account-trial-upgrade.component.html',
  styleUrls: ['./account-trial-upgrade.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccountTrialUpgradeComponent {
  @Input() accountDetails: IAccount;
  @Input() licensePackages: LicensePackage[];
  @Input() progress = false;
  @Input() sharePointUrl: string;
  @Input() hasOrderManagerRole: boolean;
  @Output() upgradeTrial = new EventEmitter<{
    accountId: string;
    subscriptionId: string;
    orderNumber: string;
    licensePackage: string;
  }>();

  public AccountState = AccountState;

  constructor(private readonly modalService: NgbModal) {}

  public showUpgrade() {
    const modalRef = this.modalService.open(AccountTrialUpgradeModalComponent, {
      backdrop: 'static',
      keyboard: false,
    });

    const { componentInstance } = modalRef;
    componentInstance.licensePackages = this.licensePackages;
    componentInstance.accountDetails = this.accountDetails;
    componentInstance.upgradeTrial.subscribe((upgradePayload) =>
      this.upgradeTrial.emit(upgradePayload),
    );
  }

  public tooltipMessage() {
    if (!this.hasOrderManagerRole) {
      return 'You have to be an Order Manager to upgrade Trial accounts';
    }
    if (this.accountDetails.state === AccountState.Locked) {
      return 'Activate this Trial account before upgrading it';
    }
    if (this.accountDetails.state !== AccountState.Success) {
      return 'This Trial account can not be upgraded as it either failed to create or has been suspended, terminated or deleted';
    }
  }
}
